import { connect } from 'react-redux';
import AutoAllocateWeightings from '../../../components/Admin/AutoAllocateWeightings/AutoAllocateWeightings';
import { getAutoAllocateWeightings, updateAutoAllocateWeightings } from '../../../actions/areas/admin';

const mapStateToProps = state => {
  const {
    uiElements: { tables },
  } = state;
  return {
    tables,
  };
};

const mapDispatchToProps = dispatch => ({
  getAutoAllocateWeightings: () => dispatch(getAutoAllocateWeightings()),
  updateAutoAllocateWeightings: data => dispatch(updateAutoAllocateWeightings(data)),
});

const AutoAllocateWeightingsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AutoAllocateWeightings);

export default AutoAllocateWeightingsPage;
